module.exports = __webpack_public_path__ + "img/Frente-37-01 on.c65fa9c0.png";